import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../modules_v2/shared/services/base.service';

@Injectable({ providedIn: 'root' })
export class AppointmentService extends BaseService<any, any> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/appointments');
  }
}